import Index from '@/pages/setting/Index'
import List from '@/pages/setting/List'

export default {
  path: 'setting',
  component: Index,
  children: [
    {
      path: 'index',
      component: List
    }
  ]
}